var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "findly-mobile-nav",
      class: { "is-open": _vm.isOpen },
      attrs: {
        id: "findly-mobile-nav",
        role: "dialog",
        "aria-label": "Mobile Navigation",
        "aria-hidden": "!isOpen",
      },
    },
    [
      _c("div", {
        staticClass: "findly-mobile-nav__overlay",
        attrs: { "aria-hidden": "true" },
        on: { click: _vm.close },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "findly-mobile-nav__panel" }, [
        _c("div", { staticClass: "findly-mobile-nav__header" }, [
          _c(
            "button",
            {
              staticClass: "findly-mobile-nav__close btn btn-link",
              attrs: {
                "aria-label": _vm.$translate("Ceres::Template.closeIcon"),
              },
              on: { click: _vm.close },
            },
            [
              _c("i", {
                staticClass: "fa fa-times",
                attrs: { "aria-hidden": "true" },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "findly-mobile-nav__title" },
            [
              _vm.currentLevel > 0 && _vm.activeParent
                ? [
                    _c(
                      "button",
                      {
                        staticClass: "findly-mobile-nav__back btn btn-link",
                        on: { click: _vm.goBack },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-chevron-left",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.activeParent.name) +
                        "\n                "
                    ),
                  ]
                : [_vm._v("\n                    Menü\n                ")],
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "findly-mobile-nav__body" },
          [
            _c("transition", { attrs: { name: _vm.slideDirection } }, [
              _vm.currentLevel === 0
                ? _c(
                    "ul",
                    {
                      key: "level-0",
                      staticClass: "findly-mobile-nav__list list-unstyled mb-0",
                    },
                    _vm._l(_vm.navigationTree, function (category) {
                      return _c(
                        "li",
                        {
                          key: category.id,
                          staticClass: "findly-mobile-nav__item",
                        },
                        [
                          !category.children || category.children.length === 0
                            ? _c(
                                "a",
                                {
                                  staticClass: "findly-mobile-nav__link",
                                  attrs: { href: category.url },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(category.name) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "findly-mobile-nav__link-wrap d-flex",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "findly-mobile-nav__link flex-fill",
                                      attrs: { href: category.url },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(category.name) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "findly-mobile-nav__toggle btn btn-link",
                                      attrs: {
                                        "aria-label":
                                          "Untermenü öffnen: " + category.name,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openLevel(category)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-chevron-right",
                                        attrs: { "aria-hidden": "true" },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                        ]
                      )
                    }),
                    0
                  )
                : _c(
                    "ul",
                    {
                      key: "level-sub",
                      staticClass: "findly-mobile-nav__list list-unstyled mb-0",
                    },
                    [
                      _c(
                        "li",
                        {
                          staticClass:
                            "findly-mobile-nav__item findly-mobile-nav__item--all",
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass:
                                "findly-mobile-nav__link findly-mobile-nav__link--all",
                              attrs: { href: _vm.activeParent.url },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-th-large mr-2",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(
                                "\n                            Alle " +
                                  _vm._s(_vm.activeParent.name) +
                                  " anzeigen\n                        "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.activeChildren, function (child) {
                        return _c(
                          "li",
                          {
                            key: child.id,
                            staticClass: "findly-mobile-nav__item",
                          },
                          [
                            !child.children || child.children.length === 0
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "findly-mobile-nav__link",
                                    attrs: { href: child.url },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(child.name) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "findly-mobile-nav__link-wrap d-flex",
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "findly-mobile-nav__link flex-fill",
                                        attrs: { href: child.url },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(child.name) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "findly-mobile-nav__toggle btn btn-link",
                                        attrs: {
                                          "aria-label":
                                            "Untermenü öffnen: " + child.name,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openLevel(child)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-chevron-right",
                                          attrs: { "aria-hidden": "true" },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
            ]),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }